import PropTypes from 'prop-types';
import './styles/addressLookup.css';
import SmartyUSResults from './components/SmartyUSResults';
import SmartyIntlResults from './components/SmartyIntlResults';
import { addressPropType, formDefinitionPropType, labelStringsPropType } from './utils/componentPropTypes';

const AddressLookup = ({ 
  onAddressSelect, 
  country = 'US',
  address = null,
  requireValidation = true,
  readOnlyView = false,
  showManualValidateButton = false,
  validationRequestId = 0,
  language = 'en',
  strings = null,
  formDefinition = null,
  deferFormLookup = false
}) => {
  const isUS = country === 'US';

  return (
    <div className='ns-address-lookup'>
      {isUS ? (
        <SmartyUSResults 
          onSelect={onAddressSelect}
          initialAddress={address}
          requireValidation={requireValidation}
          readOnlyView={readOnlyView}
          showManualValidateButton={showManualValidateButton}
          validationRequestId={validationRequestId}
          language={language}
          strings={strings}
          formDefinition={formDefinition}
          deferFormLookup={deferFormLookup}
        />
      ) : (
        <SmartyIntlResults 
          countryCode={country}
          onSelect={onAddressSelect}
          initialAddress={address}
          requireValidation={requireValidation}
          readOnlyView={readOnlyView}
          showManualValidateButton={showManualValidateButton}
          validationRequestId={validationRequestId}
          language={language}
          strings={strings}
          formDefinition={formDefinition}
          deferFormLookup={deferFormLookup}
        />
      )}
    </div>
  );
};

AddressLookup.propTypes = {
  onAddressSelect: PropTypes.func,
  country: PropTypes.string,
  address: addressPropType,
  requireValidation: PropTypes.bool,
  readOnlyView: PropTypes.bool,
  showManualValidateButton: PropTypes.bool,
  validationRequestId: PropTypes.number,
  language: PropTypes.string,
  strings: labelStringsPropType,
  formDefinition: formDefinitionPropType,
  deferFormLookup: PropTypes.bool
};

export default AddressLookup;
